import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=0ebecb90&scoped=true&"
import script from "./UnderConstruction.vue?vue&type=script&lang=js&"
export * from "./UnderConstruction.vue?vue&type=script&lang=js&"
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&id=0ebecb90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebecb90",
  null
  
)

export default component.exports